import { isValidElement } from "react";
import { isTamaguiComponent } from "./isTamaguiComponent";
const isTamaguiElement = (child, name) => isValidElement(child) && isTamaguiComponent(child.type, name);
export {
  isTamaguiElement
};
